<template lang="pug">
  .b-svg
    svg(
      viewBox="0 0 24 24"
    )
      path(:d="path")
</template>

<script>
export default {
  name: 'SVGIcon',
  props: {
    path: String,
  },
};
</script>
